var map = {
	"./MGL-Chevron.svg": 1564,
	"./MGL-map-pin.svg": 8357,
	"./McDougallGauley-Logo.svg": 1341,
	"./brand-motif-short.svg": 9686,
	"./brand-motif-tall.svg": 4429,
	"./chevron-down.svg": 2532,
	"./quote-icon.svg": 4044,
	"./right-arrow-dark.svg": 1489,
	"./right-arrow.svg": 76
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7288;